const data = {
	"width": 24,
	"height": 24,
	"body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"><path d=\"M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0\"/><path d=\"M15.51 15.56A5 5 0 1 0 12 17\"/><path d=\"M18.832 17.86A9 9 0 1 0 12 21m0-9v9\"/></g>"
};
export default data;
